import { Head, Link } from "@inertiajs/react"
import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { AdminHeader } from "@/components/admin-header"
import { Music, Users, TrendingUp } from "lucide-react"

type Props = {
  stats: {
    total_samples: number
    total_users: number
    samples_this_week: number
    users_this_week: number
  }
}

export default function Dashboard({ stats }: Props) {
  return (
    <div className="min-h-screen">
      <Head title="Admin Dashboard" />
      <AdminHeader />

      <main className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-mono font-bold mb-8">DASHBOARD</h1>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          <Card className="p-6">
            <div className="flex items-center gap-3 mb-2">
              <Music className="h-5 w-5 text-primary" />
              <span className="text-sm text-muted-foreground">Total Samples</span>
            </div>
            <div className="text-3xl font-mono font-bold">{stats.total_samples}</div>
          </Card>

          <Card className="p-6">
            <div className="flex items-center gap-3 mb-2">
              <Users className="h-5 w-5 text-primary" />
              <span className="text-sm text-muted-foreground">Total Users</span>
            </div>
            <div className="text-3xl font-mono font-bold">{stats.total_users}</div>
          </Card>

          <Card className="p-6">
            <div className="flex items-center gap-3 mb-2">
              <TrendingUp className="h-5 w-5 text-green-500" />
              <span className="text-sm text-muted-foreground">Samples (7d)</span>
            </div>
            <div className="text-3xl font-mono font-bold">+{stats.samples_this_week}</div>
          </Card>

          <Card className="p-6">
            <div className="flex items-center gap-3 mb-2">
              <TrendingUp className="h-5 w-5 text-green-500" />
              <span className="text-sm text-muted-foreground">Users (7d)</span>
            </div>
            <div className="text-3xl font-mono font-bold">+{stats.users_this_week}</div>
          </Card>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          <Card className="p-6">
            <h2 className="text-lg font-mono font-bold mb-4">Quick Actions</h2>
            <div className="space-y-2">
              <Button variant="secondary" className="w-full justify-start" asChild>
                <Link href="/admin/samples">Manage Samples</Link>
              </Button>
              <Button variant="secondary" className="w-full justify-start" asChild>
                <Link href="/admin/users">Manage Users</Link>
              </Button>
            </div>
          </Card>
        </div>
      </main>
    </div>
  )
}
